import { typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

const positionReference = [
  {
    top: '71%',
    right: '50px',
    transform: '0',
    color: '#E5484D',
  },
  {
    top: '54%',
    right: '47px',
    transform: '35deg',
    color: '#E54D2E',
  },
  {
    top: '35%',
    right: '60px',
    transform: '70deg',
    color: '#F76808',
  },
  {
    top: '23%',
    right: '87px',
    transform: '96deg',
    color: '#FFB224',
  },
  {
    top: '22%',
    right: '116px',
    transform: '126deg',
    color: '#C4F042',
  },
  {
    top: '29%',
    right: '144px',
    transform: '154deg',
    color: '#99D52A',
  },
  {
    top: '47%',
    right: '163px',
    transform: '183deg',
    color: '#63C174',
  },
  {
    top: '64%',
    right: '167px',
    transform: '219deg',
    color: '#46A758',
  },
];

export const AssessmentHeader = styled.div`
  display: flex;
`;

export const QualityGaugeBackground = styled.div`
  background-image: url('/app/static/images/assessment/assessment-dial.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  height: 160px;
  width: 200px;
  position: relative;
  z-index: 0;
`;

export const GaugeVerdictWrapper = styled.span<{ $value: number }>`
  ${typographyV2.title3XL}
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ $value }) => positionReference[$value - 1].color};
`;

export const GaugeVerdict = styled.div`
  ${typographyV2.bodyXs}
  padding: 4px;
  border: 1px solid;
  border-radius: 4px;
`;

export const GaugeArrow = styled.span<{ $value: number }>`
  display: block;
  position: absolute;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 13px solid white;
  transform-origin: center;
  z-index: 1;
  ${({ $value }) => {
    const position = positionReference[$value - 1];
    return css`
      transform: rotate(calc(-200deg + ${position.transform})) translateX(50%)
        translateY(50%);
      top: ${position.top};
      right: calc(100% - ${position.right});
    `;
  }}
`;
